import storeConfig from './storeConfig';

export default storeConfig;
